module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-144x144-e2c5a00aa28e6ceb85e51138fc83e2ed.png";